import React from 'react';
import BackButtonPage from '../../../../../components/BackButtonPage';

function EgyeHajobanKapcs() {
    return (
        <>


            <div className='page-content-container'>
                <p>
                    Az új bázishelyszínünkön, Adonyban talált ránk 2023-ban, a 2016-óta folyamatosan 
                    minden évben megrendezett Mohács-emléktúra szervezőinek ötlete, miszerint egy 
                    középkori hajónkkal vegyünk részt a kezdeményezésükben és a Dunán kísérjük végig 
                    a történelmi zarándoklatuk lovastúráját. Eger Gabriella, a túra lovasainak képviseletében 
                    látogatott el hozzánk és elmesélte, hogy a Dr Négyesi Lajos hadtörténész professzor 
                    által indított (és minden évben végigjárt) zarándoktúra a II. Lajos Mohácsra 
                    vonuló hadának útját jelző emlékművek mentén zajlik, több lovasegyesület részvételével. 
                    Mivel ez az út a Duna menti települések során vezet keresztül, adta magát 
                    számukra az ötlet, hogy a kerékpáros, gyalogos és lovas zarándokok mellett járja végig 
                    egy evezős hajó is a zarándoklatot. (A túra hajós vonatkozásának történelmi háttere, 
                    hogy a Mohácsi csatasíkra igyekvő magyar királyi hadat naszádokból, és egyéb hajókból 
                    álló flotta kísérte az oszmán birodalom roppant serege elleni hősies, ámde végzetes 
                    csatájába. Ez a hajóhad volt az utolsó nagy középkori magyar dunai flotta.)
                </p>
                <p>
                    Természetesen örömmel csatlakoztunk ehhez az emléktúrához. Olyannyira, hogy 
                    kidolgoztunk egy hároméves munkatervet, amelynek mentén ennek keretében folytatjuk 
                    az Egy hajóban… programot.
                    Megállapodtunk a Mohácsi Nemzeti Emlékhelyet kezelő DDNPI vezető munkatársával, 
                    Varga Zsolttal (aki a Mohácsi Nemzeti Emlékhely részéről nyolcadik éve főszervezője 
                    a történelmi zarándoklatnak), hogy Történelmi hajós projektünkkel csatlakozva ehhez 
                    a szép kezdeményezéshez, igyekszünk felidézni a Mohácsi csatába vonuló királyi had 
                    Dunai flottakíséretét, hajós hagyományőrző mozgalmat generálva, létrehozva egy, a 
                    történelmi/néprajzi értékeinket népszerűsítő flotillát.
                </p>
                <BackButtonPage to="/projekt-tortenet" />
            </div>


        </> 
    );
}

export default EgyeHajobanKapcs;